import * as z from "zod";
import {
  AdditionalSelectionType,
  AdditionalItemType,
} from "@/interfaces/products";

// Alinhado com suas interfaces: AdditionalItem
export const optionItemSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, "O nome do item é obrigatório."),
  unitPrice: z.number().min(0, "O preço deve ser positivo.").default(0),
  unitCost: z.number().min(0, "O custo deve ser positivo.").default(0),
  productId: z.string().optional().nullable(), // FK para um produto que consome estoque
  fileId: z.string().optional(),
  file: z.any().optional(),
  type: z.nativeEnum(AdditionalItemType).optional(),
  consumptionFactor: z
    .number()
    .min(0, "O fator de consumo deve ser positivo.")
    .default(1),
});

// Alinhado com suas interfaces: ProductAdditional
export const optionGroupSchema = z
  .object({
    id: z.string().optional(),
    name: z.string().min(1, "O nome do grupo é obrigatório."),
    selectionType: z.nativeEnum(AdditionalSelectionType),
    minQuantity: z.number().min(0, "A quantidade mínima deve ser positiva."),
    maxQuantity: z
      .number()
      .min(1, "A quantidade máxima deve ser pelo menos 1."),
    items: z.array(optionItemSchema),
  })
  .refine((data) => data.maxQuantity >= data.minQuantity, {
    message: "A quantidade máxima não pode ser menor que a mínima.",
    path: ["maxQuantity"],
  });

// Alinhado com suas interfaces: Product
export const schema = z.object({
  name: z.string().min(1, "O nome do produto é obrigatório."),
  description: z.string().optional(),
  sku: z.string().optional(),
  tags: z.array(z.string()).default([]),
  unitPrice: z.number().min(0, "O preço base deve ser positivo."),
  unitCost: z.number().min(0, "O custo base deve ser positivo."),
  imageUrl: z.string().optional(),
  additional: z.array(optionGroupSchema).default([]),
});

export type ProductFormValues = z.infer<typeof schema>;
export type OptionGroupValues = z.infer<typeof optionGroupSchema>;
export type OptionItemValues = z.infer<typeof optionItemSchema>;
